import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {UntypedFormControl} from "@angular/forms";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";


export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];


@Component({
  selector: 'app-ace-pagination',
  templateUrl: './ace-pagination.component.html',
  styleUrls: ['./ace-pagination.component.scss'],
  standalone: false
})
export class AcePaginationComponent implements OnInit, OnChanges, OnDestroy {

  private readonly ngUnsubscribe: Subject<void> = new Subject();
  private readonly DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZE_OPTIONS[0];
  private readonly NON_NUMBER_REGEX = /\D/g;

  readonly NGB_ELLIPSIS_PAGE_NUMBER = -1;

  @Input() count: number;
  @Input() page: number;
  @Input() pageSize = this.DEFAULT_PAGE_SIZE;
  @Input() pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS;
  @Input() numberOfPagesDisplayed = 5;
  @Input() showEllipsis = false;
  @Input() rotate = true;
  @Input() boundaryLinks = true;

  @Input() showTotalCount = true;
  @Input() showPageSizeSelect = true;
  @Input() showJumpToPage = true;
  @Input() showPagesForSinglePage = false;

  @Output() changePageSize: EventEmitter<number> = new EventEmitter();
  @Output() changePage: EventEmitter<number> = new EventEmitter();

  pageSizeControl: UntypedFormControl;

  constructor() {
  }

  ngOnInit() {
    this.pageSizeControl = new UntypedFormControl(this.pageSize);
    this.pageSizeControl.valueChanges
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(pageSize => this.changePageSize.next(pageSize));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.pageSize || changes.pageSizeOptions) {
      if (this.pageSizeOptions.findIndex((size) => size === this.pageSize) === -1) {
        // NOTE: javascript sort without comparator will default to sort items by ascii code
        // so [10, 20, 4, 50] will stay [10, 20, 4, 50], [10, 20, 6, 50] will become [10, 20, 50, 6]
        this.pageSizeOptions = [...this.pageSizeOptions, this.pageSize].sort((a, b) => a - b);
      }
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  jumpToPage(pageValue: string) {
    const page = this.formatValue(pageValue);
    this.setCurrentPage(page, true);
  }

  setPageSize(pageSize: number, emitEvent = false) {
    this.pageSizeControl.setValue(pageSize, { emitEvent });
  }

  setCurrentPage(page: number, emitEvent = false) {
    if (page !== this.page) {
      this.page = page;
      if (emitEvent) {
        this.changePage.next(page);
      }
    }
  }

  private formatValue(value: string): number {
    return parseInt(value.replace(this.NON_NUMBER_REGEX, '')) || 1;
  }
}
